import { Slide } from '@features/powerpoint';
import { howWeDoItSlide as baseSlide } from '@features/lci-report/slides/appendix/how-we-do-it-slide';

export const howWeDoItSlide = (): Slide => {
  return baseSlide({
    toplineText:
      '<lci>Lift Conversion Index (LCI®)</lci>, powered by industry-leading, robust consumer visit and sales data, ' +
      'provides the most accurate and holistic view into how your media drives consumer visits and sales!',
    conversionText: 'Audience visits a store and/or makes a purchase',
    attributionText:
      'LCI measures incremental lift in visits and in-store + online sales!',
  });
};
